/* Shared by all eight /alternatives use-case tables. Each competitor's `fit`
   union is its own ("Proxidize" | "Oxylabs" | "Both", etc.), so the prop is a
   plain string and the three states are derived by comparison — the same way
   every per-competitor copy did before this was extracted. */

/* Three states, three treatments: blue where Proxidize is the better fit,
   the warm secondary where the competitor is, and a plain outline for a tie.
   The label always says which, so the hue is reinforcement rather than the
   only signal. */
const FIT_STYLES = {
  proxidize: "var(--brand-green)",
  competitor: "var(--brand-yellow)",
} as const;

interface Props {
  /** The competitor-specific fit value, e.g. "Proxidize" | "Oxylabs" | "Both". */
  fit: string;
}

export default function FitBadge({ fit }: Props) {
  const isProxidize = fit === "Proxidize";
  const isBoth = fit === "Both";
  const accent = isProxidize ? FIT_STYLES.proxidize : FIT_STYLES.competitor;
  const text = isProxidize ? "var(--brand-green)" : "var(--yellow-accent)";

  return (
    <span
      className="relative inline-flex w-fit items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold"
      style={
        isBoth
          ? undefined
          : {
              color: text,
              borderColor: `color-mix(in srgb, ${accent} 35%, transparent)`,
              backgroundColor: `color-mix(in srgb, ${accent} 10%, transparent)`,
            }
      }
    >
      {isBoth ? "Either works" : `Better fit: ${fit}`}
    </span>
  );
}
